import React from 'react'
import { PlayerProvider } from '../context/player-context'
import GlobalAudioPlayer from './GlobalAudioPlayer'

export default function AppShell({ children }) {
  return (
    <PlayerProvider>
      {children}
      <GlobalAudioPlayer />
    </PlayerProvider>
  )
}